import {Frontend} from "./frontend";

(function () {
    XonBoard.SensorTypes = {
        list: {

            selectors: {
                sensor_types_table: $('#sensor-types-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sensor_types_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_types_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {data: 'name', name: 'sensor_types.name'},
                        {data: 'description', name: 'sensor_types.description'},
                        {data: 'status', name: 'sensor_types.status'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                const onCreatedSuccessfully = function (data) {
                    if(data.edit_config_url) {
                        XonBoard.Utils.EditByUrl(data.edit_config_url);
                    }
                };

                Frontend.DataTable.init(table, onCreatedSuccessfully);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
